import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/AuthContext";
import HomePage from "@/components/HomePage";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import DashboardLayout from "@/dashboard/DashboardLayout";
import Overview from "@/dashboard/Overview";
import Leads from "@/dashboard/Leads";
import Appointments from "@/dashboard/Appointments";
import VoiceAgents from "@/dashboard/VoiceAgents";
import TalkToAI from "@/dashboard/TalkToAI";
import Calling from "@/dashboard/Calling";
import IncomingCalls from "@/dashboard/IncomingCalls";
import TelephonyNumbers from "@/dashboard/TelephonyNumbers";
import Marketing from "@/dashboard/Marketing";
import Automations from "@/dashboard/Automations";
import Analytics from "@/dashboard/Analytics";
import Reports from "@/dashboard/Reports";
import Settings from "@/dashboard/Settings";
import OwnerConsole from "@/dashboard/OwnerConsole";
import PublicLandingPage from "@/pages/PublicLandingPage";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import FaqPage from "@/pages/FaqPage";
import AiCallingPolicy from "@/pages/AiCallingPolicy";
import DataProcessing from "@/pages/DataProcessing";
import Cookies from "@/pages/Cookies";
import Support from "@/pages/Support";
import ManageBooking from "@/pages/ManageBooking";
import ProductPage from "@/pages/ProductPage";
import AiVoiceAgentsPage from "@/pages/AiVoiceAgentsPage";
import AiMarketingPage from "@/pages/AiMarketingPage";
import CrmPage from "@/pages/CrmPage";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white text-sm text-neutral-400">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Login initialMode="register" />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/lp/:slug" element={<PublicLandingPage />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/ai-calling-policy" element={<AiCallingPolicy />} />
          <Route path="/data-processing" element={<DataProcessing />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/support" element={<Support />} />
          <Route path="/booking/:token" element={<ManageBooking />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/ai-voice-agents" element={<AiVoiceAgentsPage />} />
          <Route path="/ai-marketing" element={<AiMarketingPage />} />
          <Route path="/crm" element={<CrmPage />} />
          <Route
            path="/dashboard"
            element={
              <Protected>
                <DashboardLayout />
              </Protected>
            }
          >
            <Route index element={<Overview />} />
            <Route path="leads" element={<Leads />} />
            <Route path="appointments" element={<Appointments />} />
            <Route path="voice-agents" element={<VoiceAgents />} />
            <Route path="talk" element={<TalkToAI />} />
            <Route path="calling" element={<Calling />} />
            <Route path="incoming-calls" element={<IncomingCalls />} />
            <Route path="phone-numbers" element={<TelephonyNumbers />} />
            <Route path="marketing" element={<Marketing />} />
            <Route path="automations" element={<Automations />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
            <Route path="owner-console" element={<OwnerConsole />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
